module.exports = __webpack_public_path__ + "img/group123.7eb1a325.png";